<template>
  <div class="flex h-[45px] w-full border-b border-slate-200 bg-slate-50 px-6 py-1.5 pr-[18px]">
    <div class="flex grow flex-col gap-4 md:flex-row">
      <slot />
    </div>
  </div>
</template>
